/* ============================================================
   c_video-modal.js — 共通動画モーダル driver
   [data-video-open]（data-video-src=mp4 / data-video-url=YouTube等）クリックで、
   同じ .shopify-section 内の [data-video-modal] をポップアップ再生する。
   c_artist-profile / c_about-story 共通。旧 c_artist-profile インラインJSを集約。
   ============================================================ */
(function () {
  function ytId(url) {
    var m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]+)/);
    return m ? m[1] : '';
  }
  function openModal(btn, modal, body) {
    var src = btn.getAttribute('data-video-src');
    var url = btn.getAttribute('data-video-url');
    if (src) {
      body.innerHTML = '<video class="c-video-modal__media" controls autoplay playsinline src="' + src + '"></video>';
    } else if (url) {
      var id = ytId(url);
      body.innerHTML = id
        ? '<iframe class="c-video-modal__media" src="https://www.youtube.com/embed/' + id + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>'
        : '<video class="c-video-modal__media" controls autoplay playsinline src="' + url + '"></video>';
    } else { return; }
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal(modal, body) {
    modal.hidden = true;
    body.innerHTML = '';
    document.body.style.overflow = '';
  }
  function initOne(btn) {
    if (btn.dataset.vmInit) return;
    var scope = btn.closest('.shopify-section') || document;
    var modal = scope.querySelector('[data-video-modal]');
    if (!modal) return;
    var body = modal.querySelector('[data-video-body]');
    if (!body) return;
    btn.dataset.vmInit = '1';
    btn.addEventListener('click', function () { openModal(btn, modal, body); });
    if (!modal.dataset.vmInit) {
      modal.dataset.vmInit = '1';
      modal.querySelectorAll('[data-video-close]').forEach(function (c) {
        c.addEventListener('click', function () { closeModal(modal, body); });
      });
    }
  }
  function run() {
    document.querySelectorAll('[data-video-open]').forEach(initOne);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-video-modal]').forEach(function (modal) {
      if (!modal.hidden) closeModal(modal, modal.querySelector('[data-video-body]'));
    });
  });
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  // テーマエディタのセクション再描画にも追従
  document.addEventListener('shopify:section:load', run);
})();
